/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { EgridMeta } from './egridMeta';
import { HistInfoMeta } from './histInfoMeta';
import { GrundstueckId } from './grundstueckId';
import { TimePointId } from './timePointId';
import { CodeEntryMeta } from './codeEntryMeta';
import { GrundstueckNummerListEntry } from './grundstueckNummerListEntry';
import { GebaeudeArt } from './gebaeudeArt';
import { GrundstueckPermissions } from './grundstueckPermissions';


export interface GrundstueckListEntryMeta { 
    grundstueckNummer?: GrundstueckNummerListEntry;
    mGrundstueckNummer?: FieldMetaData;
    histInfo: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    isNavigierbar?: boolean;
    mIsNavigierbar?: FieldMetaData;
    grundstueckRTFpossible?: boolean;
    mGrundstueckRTFpossible?: FieldMetaData;
    grundstueckArt?: GrundstueckListEntryMeta.GrundstueckArtEnum;
    mGrundstueckArt?: FieldMetaData;
    id: GrundstueckId;
    mId?: FieldMetaData;
    permissions?: GrundstueckPermissions;
    mPermissions?: FieldMetaData;
    flaechenMaessigNichtAusgeschieden?: boolean;
    mFlaechenMaessigNichtAusgeschieden?: FieldMetaData;
    sonderrechtText?: string;
    mSonderrechtText?: FieldMetaData;
    sdrArt?: GrundstueckListEntryMeta.SdrArtEnum;
    mSdrArt?: FieldMetaData;
    isMeldungsrelevant?: boolean;
    mIsMeldungsrelevant?: FieldMetaData;
    grundstueckPDFpossible?: boolean;
    mGrundstueckPDFpossible?: FieldMetaData;
    isKopie?: boolean;
    mIsKopie?: FieldMetaData;
    flurnamen?: Array<string>;
    mFlurnamen?: FieldMetaData;
    codeUnterart?: CodeEntryMeta;
    mCodeUnterart?: FieldMetaData;
    dokulinkVerfuegbar?: GrundstueckListEntryMeta.DokulinkVerfuegbarEnum;
    mDokulinkVerfuegbar?: FieldMetaData;
    haengigeGeschaefteIds?: Array<TimePointId>;
    mHaengigeGeschaefteIds?: FieldMetaData;
    egrid?: EgridMeta;
    mEgrid?: FieldMetaData;
    flaecheQuadratMeter?: number;
    mFlaecheQuadratMeter?: FieldMetaData;
    ligArt?: GrundstueckListEntryMeta.LigArtEnum;
    mLigArt?: FieldMetaData;
    gebaeudeArten?: Array<GebaeudeArt>;
    mGebaeudeArten?: FieldMetaData;
}
export namespace GrundstueckListEntryMeta {
    export type GrundstueckArtEnum = 'STOCKWERK' | 'LIEGENSCHAFT' | 'MITEIGENTUM' | 'UNBEKANNT' | 'FOLIO' | 'BERGWERK' | 'SDR';
    export const GrundstueckArtEnum = {
        STOCKWERK: 'STOCKWERK' as GrundstueckArtEnum,
        LIEGENSCHAFT: 'LIEGENSCHAFT' as GrundstueckArtEnum,
        MITEIGENTUM: 'MITEIGENTUM' as GrundstueckArtEnum,
        UNBEKANNT: 'UNBEKANNT' as GrundstueckArtEnum,
        FOLIO: 'FOLIO' as GrundstueckArtEnum,
        BERGWERK: 'BERGWERK' as GrundstueckArtEnum,
        SDR: 'SDR' as GrundstueckArtEnum
    };
    export type SdrArtEnum = 'BAURECHT' | 'QUELLENRECHT' | 'KONZESSION' | 'UEBRIGES_RECHT';
    export const SdrArtEnum = {
        BAURECHT: 'BAURECHT' as SdrArtEnum,
        QUELLENRECHT: 'QUELLENRECHT' as SdrArtEnum,
        KONZESSION: 'KONZESSION' as SdrArtEnum,
        UEBRIGES_RECHT: 'UEBRIGES_RECHT' as SdrArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        DOKULINK_VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        DOKULINK_NICHT_VORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
    export type LigArtEnum = 'STR' | 'CFA' | 'DPI' | 'VEC' | 'VIC' | 'ADG' | 'UEBRIGEART';
    export const LigArtEnum = {
        STR: 'STR' as LigArtEnum,
        CFA: 'CFA' as LigArtEnum,
        DPI: 'DPI' as LigArtEnum,
        VEC: 'VEC' as LigArtEnum,
        VIC: 'VIC' as LigArtEnum,
        ADG: 'ADG' as LigArtEnum,
        UEBRIGEART: 'UEBRIGEART' as LigArtEnum
    };
}


